import { Instagram, MapPin, Truck, Frame } from "lucide-react";

const HIGHLIGHTS = [
  {
    icon: Frame,
    title: "Impresión sobre MDF",
    text: "Cada pieza se imprime y enmarca en nuestro taller, con materiales que duran años en tu pared.",
  },
  {
    icon: MapPin,
    title: "Desde Los Patios",
    text: "Producimos en Los Patios, Norte de Santander, con el orgullo de crear arte colombiano.",
  },
  {
    icon: Truck,
    title: "Envíos a todo el país",
    text: "Empacamos cada cuadro con protección reforzada y lo enviamos garantizado a cualquier ciudad.",
  },
];

export const AboutSection = () => {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative bg-[#C8D5C0]/30 py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-12 lg:gap-20 items-center">
          {/* Logo card */}
          <div className="flex justify-center">
            <div className="relative rounded-3xl bg-white shadow-xl shadow-slate-900/5 p-10 md:p-12 rotate-[-2deg] hover:rotate-0 transition-transform duration-500">
              <img
                src="/logo.png"
                alt="A Cuadros — El arte de ser extraordinario"
                data-testid="about-logo"
                className="w-56 md:w-64 h-auto"
              />
            </div>
          </div>

          {/* Story */}
          <div>
            <span className="inline-flex items-center gap-2 text-xs md:text-sm uppercase tracking-[0.22em] text-[#E85A3C] mb-4">
              <span className="block h-px w-8 bg-[#E85A3C]" />
              Nosotros
            </span>
            <h2
              data-testid="about-heading"
              className="font-serif text-3xl md:text-5xl text-slate-900 leading-[1.1] tracking-tight"
            >
              Somos A Cuadros
            </h2>
            <p className="mt-5 text-base md:text-lg text-slate-700 leading-relaxed max-w-2xl">
              Nacimos en <strong>Los Patios, Norte de Santander</strong>, con
              una idea sencilla: que cualquier momento extraordinario merece
              estar colgado en una pared. Imprimimos sobre MDF, enmarcamos en
              nuestro propio taller y enviamos a todo Colombia.
            </p>
            <p className="mt-4 text-base md:text-lg text-slate-700 leading-relaxed max-w-2xl">
              Desde retratos de mascotas hasta arte abstracto y frases que
              inspiran, cada cuadro sale con el mismo propósito:{" "}
              <em className="text-[#E85A3C] not-italic font-semibold">
                el arte de ser extraordinario
              </em>
              .
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
              {HIGHLIGHTS.map(({ icon: Icon, title, text }) => (
                <div key={title} className="flex flex-col gap-2">
                  <Icon className="h-5 w-5 text-[#E85A3C]" strokeWidth={1.75} />
                  <h3 className="font-serif text-base text-slate-900">
                    {title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    {text}
                  </p>
                </div>
              ))}
            </div>

            <a
              href="https://instagram.com/somosacuadros"
              target="_blank"
              rel="noreferrer"
              data-testid="about-instagram-link"
              className="mt-10 inline-flex items-center gap-2 text-sm font-medium text-slate-900 hover:text-[#E85A3C] transition-colors"
            >
              <Instagram className="h-4 w-4" />
              @somosacuadros
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
